import Image from 'next/image'
import { cn } from '@/utils/twMerge'

type NavbarChevronRightProps = {
  className?: string
}

/**
 * Green angle chevron for navbar CTA / link rows.
 * Intrinsic SVG is 20×16 — keep that aspect.
 * `mt-[3.5px]` adds space above so the stroke reads mid-line (not top-heavy).
 */
const NavbarChevronRight = ({ className }: NavbarChevronRightProps) => (
  <Image
    src="/images/angle-right-green.svg"
    width={12}
    height={10}
    alt=""
    aria-hidden="true"
    loading="lazy"
    className={cn('navbar-chevron-right mt-[3.5px] shrink-0', className)}
  />
)

export default NavbarChevronRight
